export function rgMask(value = '', defaultEmptyReturn = ''): string {
  if (!value) return defaultEmptyReturn

  return value
  //return value.replace(/\D/g, '').replace(/(\d{6})(\d{1})+?$/, '$1-$2')
}
